export const getFaqQuestionsState = state => state.faq;
